import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

// Use different cookie name than Universe client to avoid conflicts
const AUTH_COOKIE_NAME = '_auth_parent';

export const getAuthToken = () => Cookies.get(AUTH_COOKIE_NAME);

export const setAuthToken = (token, expiresIn, rememberMe) => {
  const options = {
    secure: window.location.protocol === 'https:',
    sameSite: 'strict',
  };

  if (rememberMe) {
    // expiresIn is in minutes, convert to days for cookie
    options.expires = expiresIn / (60 * 24);
  }
  // If not rememberMe, no expires = session cookie

  Cookies.set(AUTH_COOKIE_NAME, token, options);
};

export const removeAuthToken = () => {
  Cookies.remove(AUTH_COOKIE_NAME);
  localStorage.removeItem('userName');
  localStorage.removeItem('aone_selected_child');
};

export const isAuthenticated = () => {
  const token = getAuthToken();
  if (!token) return false;

  try {
    const decoded = jwtDecode(token);
    return decoded.who === 'parent';
  } catch {
    return false;
  }
};

export const getParentEmail = () => {
  const token = getAuthToken();
  if (!token) return null;

  try {
    const decoded = jwtDecode(token);
    return decoded.parent_email;
  } catch {
    return null;
  }
};

export const getUserName = () => localStorage.getItem('userName');

export const setUserName = (name) => localStorage.setItem('userName', name);
